import {localizeRateSummaryCurrency} from './localizeRateSummaryCurrency';
import {calculateRatesAndAvailability, calculateAvailability} from './calculateAvailability';
import {min as minDate} from './dateHelper';
import get from 'lodash/get';

/**
 * This is a DRY function for what gets called by the get availability data selectors.
 * There are two cases where availability data is needed.  One based off of the Trip data dates,
 * and another based off of the date picker dates, which is temporary.
 *
 * @param     {Object}
 * @property  {Object}   listing
 * @property  {string}   tripDataCurrentDate
 * @property  {string}   selectedArriveDate
 * @property  {string}   locale
 * @property  {boolean}  shouldShowRates
 */
function determineAvailability({
    listing,
    tripDataCurrentDate,
    selectedArriveDate,
    locale,
    shouldShowRates,
    useEmptyAvailability = false,
    opts
}) {
    const rateSummary = listing.rateSummary;
    const availabilityCalendar = useEmptyAvailability
        ? {availability: {}}
        : listing.availabilityCalendar;

    if (shouldShowRates) {
        // rentNightsLocalized is in format "$123,$123,$145,$145,$123,$145"
        const localizedRates = localizeRateSummaryCurrency(
            rateSummary.rentNightsConverted.split(','),
            rateSummary.travelerCurrency,
            locale
        );

        // Trims all spaces
        // @homeaway/hacommons-i18n uses Intl.NumberFormat with {currencyDisplay="code"}, which adds a space (Not in all environments).
        // We can't just use {currencyDisplay="symbol"} because of symbols mismatch on some locales.
        // It's okay to do replace here since we have rates on US locale only (hasUSCurrency)
        const localizedTrimmedRates = localizedRates.map((rate) => rate.replace(/\s/g, ''));

        // Picks the earliest date to avoid using a date range with rates for unavailable dates
        // Occasionally listing.availabilityCalendar.availability is an empty object
        const endDate = minDate(
            get(listing, 'availabilityCalendar.availability.dateRange.endDate', ''),
            rateSummary.endDate
        );

        const rateData = {
            beginDate: rateSummary.beginDate,
            endDate,
            rentNights: localizedTrimmedRates
        };

        return calculateRatesAndAvailability(
            availabilityCalendar,
            tripDataCurrentDate,
            selectedArriveDate,
            rateData,
            opts
        );
    }

    return calculateAvailability(
        availabilityCalendar,
        tripDataCurrentDate,
        selectedArriveDate,
        null,
        opts
    );
}

export default {
    determineAvailability
};

export {determineAvailability};
